<template>
  <div>
    <b-row>
      <b-col
          md="4"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>

      <b-col
          md="1"
          sm="8"
          class="my-1"
      />
      <b-col
          md="5"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Name, Telefon etc"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col
          md="2"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-button
                size="sm"
                variant="info"
                class="btn-block"
                @click="Add"
            >
              Neue Variation
            </b-button>
          </b-input-group>
        </b-form-group>

      </b-col>
      <b-col cols="12">
        <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
            @row-clicked="Click"
        >
          <template #cell(Address1)="data">
            <div v-show="data.item.FromAddress != null">
              [{{ data.item.FromAddress != null && data.item.FromAddress.AddressId }}] {{ data.item.FromAddress != null && data.item.FromAddress.Contact.Name }} - {{ data.item.FromAddress != null && data.item.FromAddress.Address.Street }} {{ data.item.FromAddress != null && data.item.FromAddress.Address.ZipCode }} {{ data.item.FromAddress != null && data.item.FromAddress.Address.Location }}
            </div>
          </template>
          <template #cell(Address2)="data">
              [{{ data.item.ToAddress != null && data.item.ToAddress.AddressId }}] {{ data.item.ToAddress != null && data.item.ToAddress.Contact.Name }} - {{ data.item.ToAddress != null && data.item.ToAddress.Address.Street }} {{ data.item.ToAddress != null && data.item.ToAddress.Address.ZipCode }} {{ data.item.ToAddress != null && data.item.ToAddress.Address.Location }}
          </template>
          <template #cell(Count)="data">
            {{ data.item.List.length}}
          </template>
        </b-table>
      </b-col>

      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  data() {
    return {
      lastClickedRow: -1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'IdentId',
          label: 'IdentId',
        },
        {
          key: 'Address1',
          label: 'Adresse 1',
        },
        {
          key: 'Address2',
          label: 'Adresse 2',
        },
        {
          key: 'Count',
          label: 'Preise',
        },
      ],
      items: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Preisvariationenliste'
    })
    this.LoadList()
    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    Add() {
      this.$router.push({
        name: 'PriceVariation',
        params: { id: 0 }
      })
    },
    FormatPrice(price) {
      return this.$options.filters.currency(price)
    },
    Click(record, index) {
      this.$router.push({
        name: 'PriceVariation',
        params: { id: record.IdentId }
      })
    },
    LoadList() {

      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/address/price/variation/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = `/address/price/variation/list/filter?filter=${this.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              this.items.push(i)
            })
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
